import React from 'react';

export default function References() {
  const logos = [
    {
      name: "Gediz",
      path: "/references/Gediz_logo.png"
    },
    {
      name: "AOSB",
      path: "/references/AOSB_logo.svg"
    },
    {
      name: "Meram",
      path: "/references/Meram_logo.png"
    },
    {
      name: "Dicle",
      path: "/references/Dicle_logo.png"
    },
    {
      name: "Bedaş",
      path: "/references/Bedas_logo.svg"
    },
    {
      name: "Enerjisa",
      path: "/references/Enerjisa_logo.svg"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white via-[var(--color-background)] to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 mb-8">
        <h2 className="text-4xl font-bold text-center text-[var(--color-primary)] mb-16">
          Elektrik Dağıtım Şirketleri ve Organize Sanayi Bölgeleri
        </h2>
      </div>
      <div className="relative w-full overflow-x-hidden">
        <div className="flex gap-16 animate-logo-slide will-change-transform">
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="flex items-center justify-center bg-white rounded-2xl shadow-md p-6 min-w-[200px] h-[120px] transition-transform duration-300 hover:scale-105">
              <img
                src={logo.path}
                alt={logo.name}
                className="max-h-20 max-w-[160px] object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          ))}
        </div>
        {/* Sol ve sağda fade efektleri */}
        <div className="pointer-events-none absolute left-0 top-0 h-full w-32 bg-gradient-to-r from-white via-white/80 to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 h-full w-32 bg-gradient-to-l from-white via-white/80 to-transparent z-10" />
      </div>
    </section>
  );
} 